/**
 * Browser IANA offset as ±HH:MM for API custom time_range payloads.
 * getTimezoneOffset() is minutes behind UTC (IST => -330 => +05:30).
 */
export function formatBrowserTimezoneOffset(date = new Date()) {
  const offsetMin = date.getTimezoneOffset();
  const sign = offsetMin <= 0 ? "+" : "-";
  const abs = Math.abs(offsetMin);
  const hh = String(Math.floor(abs / 60)).padStart(2, "0");
  const mm = String(abs % 60).padStart(2, "0");
  return `${sign}${hh}:${mm}`;
}
